import {
    FACEBOOK_EXPORT_FAIL,
    FACEBOOK_EXPORT_REQUEST,
    FACEBOOK_EXPORT_SUCCESS,
    GOOGLE_EXPORT_FAIL,
    GOOGLE_EXPORT_REQUEST,
    GOOGLE_EXPORT_SUCCESS
} from "./seoExportTypes";

export const seoExportReducer = (state = {}, action ) => {

    switch (action.type) {

        case GOOGLE_EXPORT_REQUEST:
            return { ...state, loading: true };

        case GOOGLE_EXPORT_SUCCESS:
            return {
                ...state,
                loading: false,
                google: action.payload
            };
        case GOOGLE_EXPORT_FAIL:
            return { ...state, loading: false, error: action.payload };

        case FACEBOOK_EXPORT_REQUEST:
            return { ...state, loading: true };

        case FACEBOOK_EXPORT_SUCCESS:
            return {
                ...state,
                loading: false,
                facebook: action.payload
            };
        case FACEBOOK_EXPORT_FAIL:
            return { ...state, loading: false, error: action.payload };

        default: return state;
    }
}